var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.7 455.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.94,
    y: 187.2,
    width: 336.04,
    height: 231.96,
    style: {
      fill: "#fedc49"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.78,
    y: 119.06,
    width: 362.48,
    height: 76.07,
    style: {
      fill: "#fedc49"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.94,
    y: 195.13,
    width: 336.04,
    height: 11.91,
    style: {
      fill: "#e8c43a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.94,
    y: 407.25,
    width: 336.04,
    height: 11.91,
    style: {
      fill: "#f2c538"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.78,
    y: 119.06,
    width: 362.48,
    height: 11.91,
    style: {
      fill: "#fedc49",
      mixBlendMode: "screen",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.52,
    y: 119.06,
    width: 40.35,
    height: 300.09,
    style: {
      fill: "#f82a19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,77.41v39.37a6.05,6.05,0,0,1-3.46,5.46l-68.59,32.61a6,6,0,0,1-8.65-5.46V43.67a6,6,0,0,1,8.72-5.43L194.4,72A6.06,6.06,0,0,1,197.78,77.41Z",
    style: {
      fill: "#f82a19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,114v2.83a6.05,6.05,0,0,1-3.46,5.46l-68.59,32.61a6,6,0,0,1-8.65-5.46v-4.88c1.15,1.61,2.5,2.7,4,2.38C129.14,145.15,185.85,119.39,197.78,114Z",
    style: {
      fill: "#ee1d11"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,77.41v3.74c-13.23-6.08-71.85-33.07-75.08-34.83-1.65-.9-3.76-.17-5.62,1V43.67a6,6,0,0,1,8.72-5.43L194.4,72A6.06,6.06,0,0,1,197.78,77.41Z",
    style: {
      fill: "#ff4c30"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.88,
    y1: 114.21,
    x2: 195.15,
    y2: 102.07,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.64,
    y1: 97.76,
    x2: 195.15,
    y2: 98.53,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.89,
    y1: 81.06,
    x2: 195.15,
    y2: 93.96,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,77.41v39.37a6.05,6.05,0,0,0,3.46,5.46l68.59,32.61a6,6,0,0,0,8.65-5.46V43.67a6,6,0,0,0-8.72-5.43L227,72A6.06,6.06,0,0,0,223.58,77.41Z",
    style: {
      fill: "#f82a19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,114v2.83a6.05,6.05,0,0,0,3.46,5.46l68.59,32.61a6,6,0,0,0,8.65-5.46v-4.88c-1.15,1.61-2.5,2.7-4,2.38C292.22,145.15,235.51,119.39,223.58,114Z",
    style: {
      fill: "#ee1d11"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,77.41v3.74c13.23-6.08,71.85-33.07,75.08-34.83,1.65-.9,3.76-.17,5.62,1V43.67a6,6,0,0,0-8.72-5.43L227,72A6.06,6.06,0,0,0,223.58,77.41Z",
    style: {
      fill: "#ff4c30"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.48,
    y1: 114.21,
    x2: 226.2,
    y2: 102.07,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.72,
    y1: 97.76,
    x2: 226.2,
    y2: 98.53,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.47,
    y1: 81.06,
    x2: 226.2,
    y2: 93.96,
    style: {
      fill: "none",
      stroke: "#cf2922",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      opacity: 0.30000001192092896
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.52,
    y: 66.74,
    width: 40.35,
    height: 66.65,
    rx: 13.69,
    style: {
      fill: "#cf2922"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.ec41d2ebe714d2820758de1952bf5659.svg";
export { ForwardRef as ReactComponent };